import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "./i18n";
import { App } from "./App";
import { initSentry } from "./lib/sentry";
import "./styles/global.css";
import "./styles/admin-design.css";

// Required for every `dayjs(str, "HH:mm")`-style call across the app (e.g. Hours.tsx,
// Settings.tsx TimePickers) — without this, dayjs silently falls back to native Date
// parsing, which can't parse bare time strings and produces an Invalid Date.
dayjs.extend(customParseFormat);

initSentry();

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
